import axios from 'axios';
import config from './config';
import { PYTHON_BACKEND_URL } from './constant';
import { getAuthToken } from './helpers';
import { goToLogin } from './navigation';

// Determine the API base URL
const getBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return config.SERVER_BASE_URL;
    }

    return `${protocol}//${hostname}`;
  }

  return config.SERVER_BASE_URL;
};

// Create axios instance with base URL
const apiClient = axios.create({
  baseURL: PYTHON_BACKEND_URL,
  timeout: config.API_TIMEOUT,
});

// ✅ Add auth header to every request
apiClient.interceptors.request.use(request => {
  const token = getAuthToken();
  if (token) {
    request.headers.Authorization = token;
  }

  if (process.env.NODE_ENV === 'development') {
    // console.log('API Request:', request.method.toUpperCase(), request.baseURL + request.url);
  }

  return request;
});

// Log API response details in development
apiClient.interceptors.response.use(
  response => {
    if (process.env.NODE_ENV === 'development') {
      // console.log('API Response:', response.status, response.config.method.toUpperCase(), response.config.url);
    }
    return response;
  },
  error => {
    console.log('ERROR', error, error)
    
    // ✅ Handle authentication/authorization errors
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      // goToLogin();
      console.log('auth error==>',error)
    }
    // ✅ Handle network errors (server unreachable, connection issues)
    else if (!error?.response && error?.code === 'ERR_NETWORK') {
      // You can choose to:
      // 1. Show a network error message to user
      // 2. Retry the request
      // 3. Or redirect to login if you consider network errors as auth issues
      console.error('Network Error: Server unreachable');
      // Uncomment the next line if you want to logout on network errors too
      // goToLogin();
    }
    
    if (process.env.NODE_ENV === 'development') {
      console.error('API Error:', error.message);
      if (error.response) {
        console.error('Status:', error.response.status);
        console.error('Data:', error.response.data);
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;